export default "https://cdn.questicon.mathletics.com/assets/audio/scoreResults1Star-e2d844c88dec7dd6fa1cdc5e4105caec.mp3";